<template>
	<div class="flex-column">
		<div class="full-height">
			<div>
				<label class="h6 display-block">
					아이디
					<input v-model="item.member_id" class="input-box radius-10 width-100 mt-10" placeholder="아이디를 입력하세요" maxlength="50" />
				</label>

				<label class="h6 display-block mt-10">
					이름
					<input v-model="item.member_name" class="input-box radius-10 width-100 mt-10" placeholder="이름을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					구분
					<select
						v-model="item.member_level"
						class="input-box radius-10 width-100 mt-10"
						name="member_level"
					>
						<option value="">선택하세요</option>
						<template
							v-for="(grade, g_index) in codes.M001.items"
						>
						<option
							v-if="grade.sub_code != '000' && grade.code_index < 3"
							:key="'grade_' + g_index"
							:value="grade.code_index"
						>{{ grade.code_name }}</option>
						</template>
					</select>
				</label>

				<label class="h6 display-block mt-10">
					연락처
					<input v-model="item.member_tell" class="input-box radius-10 width-100 mt-10" placeholder="연락처를 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					메모
					<textarea
						v-model="item.member_memo"
						class="input-box radius-10 width-100 mt-10"
						placeholder="메모를 입력하세요"
						lang="ko">
					</textarea>
				</label>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="postProject"
			>등록</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'MemberItem'
	, props: ['user', 'codes']
	, data: function(){
		return {
			program: {
				name: '인원 등록'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				member_level: ''
			}
		}
	}
	, methods: {
		postProject: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'projectmember/postMember'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					this.$bus.$emit('to', { name: 'MemberList'})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
	}
}
</script>